export class FleetInspectionField {
    fleetInspectionFieldId: number;
    fleetInspectionFieldName: string;
    fleetInspectionWheelId: number;
    fleetInspectionWheelName: string;
    tooltipText: string;
    isRequired: boolean;
    dataType: number;
    fleetInspectionFieldValueId: number;
    fleetInspectionFieldValue:  string[];
  }

  export class FleetInspectionFields {
      fields: FleetInspectionField[];
  }

  export class FleetInspection extends FleetInspectionFields {
    fleetInspectionId: number;
    quoteId: number;
    dtEmailed: string;
    dtCreated: string;
    emailAddresses: string;
    userId: number;
    specialPriceSetId: number;
  }